type ConfluenceDraftSiblingParentResponse = {
	status?: string | null;
	ancestors?: ReadonlyArray<{ id?: string | null } | null> | null;
} | null;

type ResolveConfluenceDraftSiblingParentOptions = {
	distinguishRootDraft: true;
};

export function resolveConfluenceDraftSiblingParent(contentId: string): Promise<string | undefined>;
export function resolveConfluenceDraftSiblingParent(
	contentId: string,
	options: ResolveConfluenceDraftSiblingParentOptions,
): Promise<string | null | undefined>;
export async function resolveConfluenceDraftSiblingParent(
	contentId: string,
	options?: ResolveConfluenceDraftSiblingParentOptions,
): Promise<string | null | undefined> {
	try {
		const response = await fetch(
			`/wiki/rest/api/content/${encodeURIComponent(contentId)}?expand=ancestors,status&status=draft,current`,
			{ credentials: 'include' },
		);
		if (!response.ok) {
			return undefined;
		}

		const payload = (await response.json()) as ConfluenceDraftSiblingParentResponse;
		if (payload?.status !== 'draft') {
			return undefined;
		}

		const ancestors = payload.ancestors;
		if (!ancestors) {
			return undefined;
		}
		if (ancestors.length === 0) {
			return options?.distinguishRootDraft ? null : undefined;
		}

		const directParentId = ancestors[ancestors.length - 1]?.id;
		return typeof directParentId === 'string' ? directParentId : undefined;
	} catch {
		return undefined;
	}
}
